//@ts-check
import React, { useState } from 'react';
import styled from 'styled-components';

import LinkButton from './LinkButton';

/**
 * @param {object} props
 * @param {string[]} [props.values]
 * @param {number} [props.maxShown]
 */
const CompactEnum = (props) => {
  const values = props?.values;
  const totalValues = values?.length;
  const [isExpanded, setIsExpanded] = useState(false);
  const maxShown = totalValues > props.maxShown + 1 && !isExpanded ? props.maxShown : totalValues; // +1 to account for the "more" link
  const shownValues = values?.slice(0, maxShown);
  const truncatedValues = values?.slice(maxShown);
  const showLinkButton = truncatedValues.length > 0 || isExpanded;
  const productsListId = 'products-list';

  if (!totalValues) {
    return null;
  }

  return (
    <>
      <StyledList id={productsListId}>
        {shownValues.map((value) => (
          <li key={value}>{value}</li>
        ))}
      </StyledList>
      {showLinkButton && (
        <LinkButton
          aria-expanded={isExpanded}
          aria-controls={productsListId}
          onPress={() => setIsExpanded((isExpanded) => !isExpanded)}
        >
          {isExpanded ? 'Show less' : `+${truncatedValues.length} more`}
        </LinkButton>
      )}
    </>
  );
};

const StyledList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export default CompactEnum;
